<template>
  <div id="app">
    <div class="nav">
      <NavigationBar />
      <DocumentTitle />
      <CacheControl />
    </div>
    <div class="main">
      <router-view />
      <Footer />
      <InitialOfflineModal />
      <SarsCoVModalPopUp />
    </div>
    <ServiceWorker />
  </div>
</template>

<script>
import { languageAdapter } from "@/services/languageAdapter";
import { checkAllElementsForUpdate } from "@/services/caching/cachingHelpers.js";
import NavigationBar from "@/components/NavigationBar";
import CacheControl from "@/components/u/CacheControl";
import DocumentTitle from "@/components/u/DocumentTitle";
import ServiceWorker from "@/components/u/ServiceWorker";
import Footer from "@/sections/Footer";
import SarsCoVModalPopUp from "@/components/SarsCoVModalPopUp";
import { isNeitherIeNorEdge } from "./services/browser";
import InitialOfflineModal from "@/components/InitialOfflineModal";

export default {
  components: {
    CacheControl,
    DocumentTitle,
    NavigationBar,
    Footer,
    SarsCoVModalPopUp,
    InitialOfflineModal,
    ServiceWorker
  },
  data() {
    return {
      refreshing: false
    };
  },
  beforeCreate() {
    this.$i18n.locale = languageAdapter.getLanguageOfUserFromPath(
      this.$route.params
    );
    this.$store.dispatch("setCachingStatus", ["de", "en"]);
    this.$store.commit("setPwaMode");
  },
  watch: {
    $route(to) {
      const lang = languageAdapter.getLanguageOfUserFromPath(to.params);
      this.$i18n.locale = lang;
      this.$store.commit("setLanguage", lang);
    }
  },
  mounted() {
    if (this.$store.state.isPwaModeActive) {
      if (this.$store.state.wasOfflineModeInitialized === "true") {
        this.checkIfElementsForThisLanguageAreCached();
        this.$modal.show("sarsCoV-modal");
      } else {
        this.$modal.show("initial-offline-modal");
      }
      checkAllElementsForUpdate();
    } else {
      this.$modal.show("sarsCoV-modal");
    }

    this.$store.commit(
      "setLanguage",
      languageAdapter.getLanguageOfUserFromPath(this.$route.params)
    );
    this.checkIfIEOrEdge();
  },
  updated() {
    this.scrollToCurrentPage();
  },
  methods: {
    scrollToCurrentPage: function() {
      var page = this.$route.params.page;
      if (page) {
        document.getElementById(page).scrollIntoView();
      }
    },
    async checkIfElementsForThisLanguageAreCached() {
      const { isCheckingCachedElements, language } = this.$store.state;

      if (isCheckingCachedElements) {
        setTimeout(() => {
          this.checkIfElementsForThisLanguageAreCached();
        }, 1000);
        return;
      }

      if (!this.$store.getters.isLanguageCached(language)) {
        this.$toasted.show(
          this.$t("files_arent_cached_for_selected_languageToast"),
          {
            position: "top-center",
            singleton: true,
            action: [
              {
                text: this.$t("open_settings"),
                onClick: (e, toastObject) => {
                  this.$modal.show("settings-modal");
                  toastObject.goAway(0);
                }
              },
              {
                text: this.$t("close"),
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                }
              }
            ]
          }
        );
      }
    },
    checkIfIEOrEdge() {
      this.$store.state.supportsPWAandFetch = isNeitherIeNorEdge;
    }
  }
};
</script>
<style>
@import "assets/css/animate.min.css";
@import "assets/css/bootstrap.min.css";
@import "assets/css/image-map-pro.min.css";
@import "assets/css/jquery.fancybox.min.css";
@import "assets/css/fonts.css";
@import "assets/css/keyframes.css";
@import "assets/css/style-xs.css";
@import "assets/css/style-s.css";
@import "assets/css/style-m.css";
@import "assets/css/style-l.css";
@import "assets/css/style-xl.css";
@import "assets/css/main_smoke.css";
#app {
  display: flex;
  flex-direction: column;
}
#app .nav {
  height: 90px;
}
#app .main {
  flex: 1;
  background: transparent;
}
</style>
